module.exports = __webpack_public_path__ + "img/logo-copaamistadiess.2cd54616.png";